import { trackingID } from '@/constants/general';

const loadGoogleTagScript = () => new Promise((resolve, reject) => {
  const buildGoogleTagScript = (w, d, s, l, i) => {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    // Initialize gtag before loading GTM
    w.gtag = function () {
      w[l].push(arguments);
    };

    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);

    j.onload = () => resolve();
    j.onerror = () => reject(new Error('Failed to load Google Tag script'));
  };

  buildGoogleTagScript(window, document, 'script', 'dataLayer', trackingID);
});

export const initGoogleTag = async () => {
  try {
    if (!window.gtag) {
      await loadGoogleTagScript();
      const awaitTimes = 10;
      let iterationCount = 0;

      const verifyGoogleTag = setInterval(() => {
        if (window.gtag) {
          window.gtagReady = true;
          clearInterval(verifyGoogleTag);
          // 🔹 Initialize Google Ads Conversion Tracking
          window.gtag('config', trackingID);
        } else {
          if (iterationCount === awaitTimes) {
            clearInterval(verifyGoogleTag);
            window.gtagReady = false;
          }
        }
        iterationCount += 1;
      }, 500);
    }
    return true;
  } catch (e) {
    console.log(`Error on Google Tag initialization: ${e.toString()}`);
  }
  return false;
};


export default initGoogleTag;
